import { Box, Stack, Typography } from "@mui/material";
import { summaryType } from "../../../../../services/api/types/reports/reports";
import { useCustomisation } from "../../../../../context/CustomisationContext";

interface ReportStatsCardsProps {
  summary: summaryType[];
}

export const ReportStatsCards: React.FC<ReportStatsCardsProps> = ({
  summary,
}) => {
  const totalAssigned = summary.reduce((sum, s) => sum + s.assignedUsers, 0);
  const totalCompleted = summary.reduce((sum, s) => sum + s.completedUsers, 0);
  const totalOverdue = summary.reduce((sum, s) => sum + s.overdueUsers, 0);
  const moduleCount = summary.length;

  const completionRate =
    totalAssigned > 0 ? Math.round((totalCompleted / totalAssigned) * 100) : 0;

  const { customisations } = useCustomisation();
  const {
    HOME: { assignmentStatusColorsSettings },
  } = customisations.customisations;

  const homeCompletedColor =
    assignmentStatusColorsSettings?.homeCompleted || "#5354D8";
  //const homePendingColor = assignmentStatusColorsSettings?.homePending;
  const homeOverdueColor =
    assignmentStatusColorsSettings?.homeOverdue || "#F04438";

  const cards = [
    {
      label: "NUMBER OF ASSIGNMENTS",
      value: totalAssigned,
      valueColor: "#067647",
      badge: `${moduleCount} module${moduleCount !== 1 ? "s" : ""}`,
      badgeBg: "#0676471A",
      badgeColor: "#067647",
      badgeBorder: "#06764733",
      badgeDot: true,
    },
    {
      label: "COMPLETION RATE",
      value: `${completionRate}%`,
      valueColor: homeCompletedColor,
      badge: `${totalCompleted} of ${totalAssigned} completed`,
      badgeBg: `${homeCompletedColor}1A`,
      badgeColor: homeCompletedColor,
      badgeBorder: `${homeCompletedColor}33`,
      badgeDot: true,
    },
    {
      label: "OVERDUE",
      value: totalOverdue,
      valueColor: homeOverdueColor,
      badge: "Requires attention",
      badgeBg: `${homeOverdueColor}2A`,
      badgeColor: homeOverdueColor,
      badgeBorder: `${homeOverdueColor}33`,
      badgeDot: true,
    },
  ];

  return (
    <Stack direction="row" gap={3} mb={3} sx={{ flexWrap: "wrap" }}>
      {cards.map((card) => (
        <Box
          key={card.label}
          sx={{
            flex: "1 1 0",
            minWidth: 180,
            border: "1px solid #E5E7EB",
            borderRadius: "12px",
            p: "16px 20px",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px #1018281A",
          }}
        >
          <Typography
            fontSize="11px"
            fontWeight={600}
            color="#6B7280"
            letterSpacing="0.05em"
            mb={1}
          >
            {card.label}
          </Typography>
          <Typography fontSize="32px" fontWeight={700} color={card.valueColor}>
            {card.value}
          </Typography>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
              mt: 1,
              px: 1,
              py: 0.25,
              borderRadius: "20px",
              backgroundColor: card.badgeBg,
              border: `1px solid ${card.badgeBorder}`,
            }}
          >
            {card.badgeDot && (
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor: card.badgeColor,
                }}
              />
            )}
            <Typography
              fontSize="12px"
              fontWeight={600}
              color={card.badgeColor}
            >
              {card.badge}
            </Typography>
          </Box>
        </Box>
      ))}
    </Stack>
  );
};
